import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const KeyWorkerState = Record({
    searchingPrimary: false,
    primarySearchResults: List(),
    hasSearchedPrimary: false,
    searchingSecondary: false,
    secondarySearchResults: List(),
    hasSearchedSecondary: false,
});

export default handleActions(
    {
        [Actions.init.type]: () => new KeyWorkerState(),
        [Actions.searchEmployee.type]: state => state.merge({searchingPrimary: true}),
        [Actions.searchEmployeeSuccess.type]: (state, {payload}) =>
            state.merge({
                primarySearchResults: payload.searchItems,
                searchingPrimary: false,
                hasSearchedPrimary: true,
            }),
        [Actions.searchEmployeeFailed.type]: state =>
            state.merge({
                searchingPrimary: false,
            }),
        [Actions.searchEmployeeAborted.type]: state =>
            state.merge({
                searchingPrimary: false,
            }),
        [Actions.searchSecondaryEmployee.type]: state => state.merge({searchingSecondary: true}),
        [Actions.searchSecondaryEmployeeSuccess.type]: (state, {payload}) =>
            state.merge({
                secondarySearchResults: payload.searchItems,
                searchingSecondary: false,
                hasSearchedSecondary: true,
            }),
        [Actions.searchSecondaryEmployeeFailed.type]: state =>
            state.merge({
                searchingSecondary: false,
            }),
        [Actions.searchSecondaryEmployeeAborted.type]: state =>
            state.merge({
                searchingSecondary: false,
            }),
    },
    new KeyWorkerState(),
);
